<section class="panel" [class.headerless]="hideHeader">
  @if (!hideHeader) {
    <header class="panel-header">
      <p class="eyebrow">Metadata</p>
      <h3>Landing page definition</h3>
    </header>
  }

  <div class="field-table">
    <label class="field-row">
      <span class="field-label">Title</span>
      <input
        [ngModel]="landingPage.title"
        placeholder="Landing page title"
        (ngModelChange)="update('title', $event)" />
    </label>

    <label class="field-row">
      <span class="field-label">Path</span>
      <div class="slug-field">
        <input
          [ngModel]="landingPage.path"
          placeholder="/landing-page"
          (ngModelChange)="update('path', $event)" />
        <button type="button" class="ghost" (click)="syncPath()">Sync</button>
      </div>
    </label>

    <label class="field-row multiline">
      <span class="field-label">Summary</span>
      <textarea
        rows="3"
        [ngModel]="landingPage.metadata.summary"
        placeholder="Short landing page summary"
        (ngModelChange)="updateMetadata('summary', $event)"></textarea>
    </label>

    <label class="field-row">
      <span class="field-label">Meta title</span>
      <input
        [ngModel]="landingPage.metadata.metaTitle"
        placeholder="Search result title"
        (ngModelChange)="updateMetadata('metaTitle', $event || null)" />
    </label>

    <label class="field-row">
      <span class="field-label">Meta image URL</span>
      <input
        [ngModel]="landingPage.metadata.metaImageUrl"
        placeholder="https://example.com/image.jpg"
        (ngModelChange)="updateMetadata('metaImageUrl', $event || null)" />
    </label>

    <label class="field-row multiline">
      <span class="field-label">Meta description</span>
      <textarea
        rows="3"
        [ngModel]="landingPage.metadata.metaDescription"
        placeholder="Search result description"
        (ngModelChange)="updateMetadata('metaDescription', $event || null)"></textarea>
    </label>

    <div class="field-row multiline">
      <span class="field-label">Tags</span>
      <cms-tag-selector
        [tags]="landingPage.tags"
        [suggestions]="tagSuggestions"
        placeholder="Add landing page tags"
        (tagsChange)="updateTags($event)" />
    </div>
  </div>
</section>
